import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import { SALES_EMAIL, SALES_PHONE_NUMBER } from '../../common/Constants';

export const AuthFooter: FunctionComponent = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="auth-footer">
      <div className="auth-footer-content">
        <div className="auth-footer-main">
          <div className="auth-footer-social">
            <a href="https://www.linkedin.com/company/payearned1/" target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-linkedin"></i>
            </a>
            <a href="https://www.youtube.com/channel/UCeGfCeEkKuMKhyl6xfS_q8w" target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-youtube"></i>
            </a>
            <a href="https://www.facebook.com/PAYearned" target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-facebook"></i>
            </a>
          </div>
          <div className="auth-footer-center">
            <div className="auth-footer-logo">
              <h1 className="PayEarnedName-title">PAYearned</h1>
              {/* <img src="/img/PAYearned-logo-long.png" alt="PAYearned" /> */}
            </div>
            <div className="auth-footer-links">
              <Link to="/terms">Terms of Service</Link>
              <span>|</span>
              <Link to="/privacy">Privacy Policy</Link>
            </div>
          </div>
          <div className="auth-footer-contact">
            <p>{SALES_PHONE_NUMBER}</p>
            <p><a href={`mailto:${SALES_EMAIL}`}>{SALES_EMAIL}</a></p>
          </div>
        </div>
        <p className="auth-footer-disclaimer">
          PAYearned is an independent software product and is not developed, endorsed, approved, sponsored or affiliated with the American Institute of Architects (AIA).
          <br />
          AIA®, G702®, G703® are registered trademarks of The American Institute of Architects. All references to AIA documents or trademarks are used solely for comparison purposes only.
        </p>
        <p className="auth-footer-copyright">
          Copyright © {currentYear} PAYearned. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default AuthFooter;
